var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { apiEndpoints } from '../app.constants';
import { BackendHttpService } from '../core/backend-http.service';
var ForgotPasswordService = /** @class */ (function (_super) {
    __extends(ForgotPasswordService, _super);
    function ForgotPasswordService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ForgotPasswordService.prototype.forgotPassword = function (email, hostName) {
        var params = JSON.stringify({ userEmail: email, hostName: hostName });
        return this.post(apiEndpoints.forgotPassword, params);
    };
    return ForgotPasswordService;
}(BackendHttpService));
export { ForgotPasswordService };



// WEBPACK FOOTER //
// ./src/app/services/forgot-password.service.ts.pre-build-optimizer.js